var ARIconButton = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['icon-button-wrapper', _vm.size],attrs:{"ar-widget-id":"ar-icon-button","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-icon-button"},on:{"click":_vm.handleIconClick,"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}},[_c('ar-icon',_vm._b({staticClass:"icon"},'ar-icon',_vm.iconPropsDecorated,false))],1)},
staticRenderFns: [],
  name: 'IconButton',
  props: {
    arWidgetMeta: String,
    iconProps: {
      type: Object,
      default: () => {},
    },
    color: {
      type: String,
      default: null,
    },
    hoveredColor: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      validator: (val) => ['small', 'large'].indexOf(val) > -1,
      default: 'small',
    },
  },

  data() {
    return {
      isHovered: false,
    };
  },

  computed: {
    computedArWidgetMeta() {
      return [
        `name=${this.iconProps.name};`,
      ].join('');
    },
    iconPropsDecorated() {
      const { name, width, height, rotate } = this.iconProps;
      let color;
      if (this.isHovered) {
        color = this.hoveredColor || this.$arStyle.color.purple500;
      } else {
        color = this.color || this.$arStyle.color.blueGrey700;
      }
      return {
        name,
        width,
        height,
        color,
        rotate: rotate || 0,
      };
    },
  },

  methods: {
    handleIconClick(e) {
      e.stopPropagation();
      this.$emit('click');
    },
    handleMouseEnter() {
      this.isHovered = true;
    },
    handleMouseLeave() {
      this.isHovered = false;
    },
  },
};

export default ARIconButton;
